<template>
  <div class="header-mobile__menu-container">
    <a-header-logo />

    <div class="header-mobile__login-global-search-wrapper">
      <a-login-button class="header-mobile__login-btn" />

      <a-global-quicksearch
        v-if="isGlobalSearchVisible"
        ref="globalSearch"
        class="header-mobile__global-search"
        :with-close-icon="true"
        :hide-label="true"
        :single-column="true"
        :scrollable="true"
        :focus-on-mount="true"
        @blur="hideGlobalSearch"
      />

      <div
        v-else
        class="header-mobile__global-search-activator"
        @click="showGlobalSearch"
      >
        <a-icon
          :icon="$options.consts.ICON.MAGNIFIER_3"
          :original="true"
          :no-hover="true"
          :width="14"
          :height="14"
          class="header-mobile__search-icon"
        />
      </div>
    </div>
    <client-only v-if="showNotifications">
      <div class="header-mobile__notifications-wrapper">
        <a-notification-icon-with-modal-widget
          :notification-count="newNotificationCount"
        />
      </div>
    </client-only>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ROUTE } from 'enums/routes'
import { REFS } from 'enums/external-refs'
import AHeaderLogo from '@/components/AHeader/AHeaderDesktop/AHeaderLogo'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import AGlobalQuicksearch from 'shared/AGlobalQuicksearch/index.vue'
import ANotificationIconWithModalWidget from '@/components/AHeader/Shared/AHeaderActions/ANotificationIconWithModalWidget/index'
import ALoginButton from 'shared/ALoginButton'

export default {
  name: 'AHeaderMobileTopSection',
  mixins: [hydrationHelpers],
  components: {
    AGlobalQuicksearch,
    AIcon,
    AHeaderLogo,
    ANotificationIconWithModalWidget,
    ALoginButton
  },
  consts: {
    REFS,
    ICON
  },
  data() {
    return {
      ROUTE,
      isGlobalSearchVisible: false
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
      isAuthFormLoaded: 'auth/isAuthFormLoaded',
      newNotificationCount: 'notifications/newNotificationCount'
    }),
    showNotifications() {
      return this.isLoggedIn && !this.isGlobalSearchVisible
    }
  },
  methods: {
    showGlobalSearch() {
      this.isGlobalSearchVisible = true
    },
    hideGlobalSearch() {
      this.isGlobalSearchVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
$globalSearch-height: 32px;

.header-mobile__menu-container {
  height: $mobile-header-height;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-mobile__global-search-activator {
    width: $globalSearch-height;
    height: $globalSearch-height;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $c--gray-darkest-2;
    border-radius: 50%;
  }

  .header-mobile__login-global-search-wrapper {
    position: relative;
    width: 100%;
    height: $globalSearch-height;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .header-mobile__actions {
    justify-content: flex-end;
    margin-left: 0;
  }

  .header-mobile__login-btn {
    width: fit-content;
    height: fit-content;
    margin-right: 8px;
    padding: 8px 16px;
    border-radius: 2px;
    font-size: 14px;
    line-height: 22px;

    /deep/ .a-button__slot-wrapper {
      align-items: center;
      padding: 0;
    }
  }

  .header-mobile__global-search {
    position: absolute;
    width: calc(100vw - 32px);
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
  }

  .header-mobile__notifications-wrapper {
    margin-left: 8px;
  }

  /deep/ .notification-icon__wrapper {
    .notification-icon__container {
      width: 32px;
      height: 32px;
    }
  }

  /deep/ .header-notification-icon {
    width: 16px;
    height: 20px;
  }
}
</style>
